/**
 * Request header the edge middleware uses to pass Vercel's edge-resolved
 * country through to SSR.
 */
export const GEO_COUNTRY_HEADER = 'x-sg-geo-country'
